// AUTO-GENERATED by scripts/generate-gitleaks-rule-ids.mjs — do not edit by hand.
// Source: https://github.com/gitleaks/gitleaks/blob/v8.30.1/config/gitleaks.toml
/**
 * The gitleaks release Kirin ships and validates rule IDs against. Must match
 * `GITLEAKS_VERSION` in extensions/agent/scripts/build-macos.sh,
 * extensions/agent/scripts/build-linux.sh,
 * extensions/agent/scripts/build-windows-installer.ps1 and
 * extensions/vscode-core/.../adapters/gitleaks/scanner.ts.
 */
export const GITLEAKS_VERSION = '8.30.1';
/** Every rule ID in the gitleaks 8.30.1 default ruleset, sorted. */
export const GITLEAKS_DEFAULT_RULE_IDS = [
    '1password-secret-key',
    '1password-service-account-token',
    'adafruit-api-key',
    'adobe-client-id',
    'adobe-client-secret',
    'age-secret-key',
    'airtable-api-key',
    'airtable-personnal-access-token',
    'algolia-api-key',
    'alibaba-access-key-id',
    'alibaba-secret-key',
    'anthropic-admin-api-key',
    'anthropic-api-key',
    'artifactory-api-key',
    'artifactory-reference-token',
    'asana-client-id',
    'asana-client-secret',
    'atlassian-api-token',
    'authress-service-client-access-key',
    'aws-access-token',
    'aws-amazon-bedrock-api-key-long-lived',
    'aws-amazon-bedrock-api-key-short-lived',
    'azure-ad-client-secret',
    'beamer-api-token',
    'bitbucket-client-id',
    'bitbucket-client-secret',
    'bittrex-access-key',
    'bittrex-secret-key',
    'cisco-meraki-api-key',
    'clickhouse-cloud-api-secret-key',
    'clojars-api-token',
    'cloudflare-api-key',
    'cloudflare-global-api-key',
    'cloudflare-origin-ca-key',
    'codecov-access-token',
    'cohere-api-token',
    'coinbase-access-token',
    'confluent-access-token',
    'confluent-secret-key',
    'contentful-delivery-api-token',
    'curl-auth-header',
    'curl-auth-user',
    'databricks-api-token',
    'datadog-access-token',
    'defined-networking-api-token',
    'digitalocean-access-token',
    'digitalocean-pat',
    'digitalocean-refresh-token',
    'discord-api-token',
    'discord-client-id',
    'discord-client-secret',
    'doppler-api-token',
    'droneci-access-token',
    'dropbox-api-token',
    'dropbox-long-lived-api-token',
    'dropbox-short-lived-api-token',
    'duffel-api-token',
    'dynatrace-api-token',
    'easypost-api-token',
    'easypost-test-api-token',
    'etsy-access-token',
    'facebook-access-token',
    'facebook-page-access-token',
    'facebook-secret',
    'fastly-api-token',
    'finicity-api-token',
    'finicity-client-secret',
    'finnhub-access-token',
    'flickr-access-token',
    'flutterwave-encryption-key',
    'flutterwave-public-key',
    'flutterwave-secret-key',
    'flyio-access-token',
    'frameio-api-token',
    'freemius-secret-key',
    'freshbooks-access-token',
    'gcp-api-key',
    'generic-api-key',
    'github-app-token',
    'github-fine-grained-pat',
    'github-oauth',
    'github-pat',
    'github-refresh-token',
    'gitlab-cicd-job-token',
    'gitlab-deploy-token',
    'gitlab-feature-flag-client-token',
    'gitlab-feed-token',
    'gitlab-incoming-mail-token',
    'gitlab-kubernetes-agent-token',
    'gitlab-oauth-app-secret',
    'gitlab-pat',
    'gitlab-pat-routable',
    'gitlab-ptt',
    'gitlab-rrt',
    'gitlab-runner-authentication-token',
    'gitlab-runner-authentication-token-routable',
    'gitlab-scim-token',
    'gitlab-session-cookie',
    'gitter-access-token',
    'gocardless-api-token',
    'grafana-api-key',
    'grafana-cloud-api-token',
    'grafana-service-account-token',
    'harness-api-key',
    'hashicorp-tf-api-token',
    'hashicorp-tf-password',
    'heroku-api-key',
    'heroku-api-key-v2',
    'hubspot-api-key',
    'huggingface-access-token',
    'huggingface-organization-api-token',
    'infracost-api-token',
    'intercom-api-key',
    'intra42-client-secret',
    'jfrog-api-key',
    'jfrog-identity-token',
    'jwt',
    'jwt-base64',
    'kraken-access-token',
    'kubernetes-secret-yaml',
    'kucoin-access-token',
    'kucoin-secret-key',
    'launchdarkly-access-token',
    'linear-api-key',
    'linear-client-secret',
    'linkedin-client-id',
    'linkedin-client-secret',
    'lob-api-key',
    'lob-pub-api-key',
    'looker-client-id',
    'looker-client-secret',
    'mailchimp-api-key',
    'mailgun-private-api-token',
    'mailgun-pub-key',
    'mailgun-signing-key',
    'mapbox-api-token',
    'mattermost-access-token',
    'maxmind-license-key',
    'messagebird-api-token',
    'messagebird-client-id',
    'microsoft-teams-webhook',
    'netlify-access-token',
    'new-relic-browser-api-token',
    'new-relic-insert-key',
    'new-relic-user-api-id',
    'new-relic-user-api-key',
    'notion-api-token',
    'npm-access-token',
    'nuget-config-password',
    'nytimes-access-token',
    'octopus-deploy-api-key',
    'okta-access-token',
    'openai-api-key',
    'openshift-user-token',
    'perplexity-api-key',
    'pkcs12-file',
    'plaid-api-token',
    'plaid-client-id',
    'plaid-secret-key',
    'planetscale-api-token',
    'planetscale-oauth-token',
    'planetscale-password',
    'postman-api-token',
    'prefect-api-token',
    'private-key',
    'privateai-api-token',
    'pulumi-api-token',
    'pypi-upload-token',
    'rapidapi-access-token',
    'readme-api-token',
    'rubygems-api-token',
    'scalingo-api-token',
    'sendbird-access-id',
    'sendbird-access-token',
    'sendgrid-api-token',
    'sendinblue-api-token',
    'sentry-access-token',
    'sentry-org-token',
    'sentry-user-token',
    'settlemint-application-access-token',
    'settlemint-personal-access-token',
    'settlemint-service-access-token',
    'shippo-api-token',
    'shopify-access-token',
    'shopify-custom-access-token',
    'shopify-private-app-access-token',
    'shopify-shared-secret',
    'sidekiq-secret',
    'sidekiq-sensitive-url',
    'slack-app-token',
    'slack-bot-token',
    'slack-config-access-token',
    'slack-config-refresh-token',
    'slack-legacy-bot-token',
    'slack-legacy-token',
    'slack-legacy-workspace-token',
    'slack-user-token',
    'slack-webhook-url',
    'snyk-api-token',
    'sonar-api-token',
    'sourcegraph-access-token',
    'square-access-token',
    'squarespace-access-token',
    'stripe-access-token',
    'sumologic-access-id',
    'sumologic-access-token',
    'telegram-bot-api-token',
    'travisci-access-token',
    'twilio-api-key',
    'twitch-api-token',
    'twitter-access-secret',
    'twitter-access-token',
    'twitter-api-key',
    'twitter-api-secret',
    'twitter-bearer-token',
    'typeform-api-token',
    'vault-batch-token',
    'vault-service-token',
    'yandex-access-token',
    'yandex-api-key',
    'yandex-aws-access-token',
    'zendesk-secret-key',
];
/** Set form, for O(1) membership checks. */
export const GITLEAKS_DEFAULT_RULE_ID_SET = new Set(GITLEAKS_DEFAULT_RULE_IDS);
/** Every built-in rule with its metadata, sorted by `id`. */
export const GITLEAKS_RULES = [
    {
        id: '1password-secret-key',
        name: '1Password Secret Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a possible 1Password secret key, potentially compromising access to secrets in vaults.',
    },
    {
        id: '1password-service-account-token',
        name: '1Password Service Account Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a possible 1Password service account token, potentially compromising access to secrets in vaults.',
    },
    {
        id: 'adafruit-api-key',
        name: 'Adafruit API Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a potential Adafruit API Key, which could lead to unauthorized access to Adafruit services and sensitive data exposure.',
    },
    {
        id: 'adobe-client-id',
        name: 'Adobe Client ID',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a pattern that resembles an Adobe OAuth Web Client ID, posing a risk of compromised Adobe integrations and data breaches.',
    },
    {
        id: 'adobe-client-secret',
        name: 'Adobe Client Secret',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a potential Adobe Client Secret, which, if exposed, could allow unauthorized Adobe service access and data manipulation.',
    },
    {
        id: 'age-secret-key',
        name: 'Age Secret Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a potential Age encryption tool secret key, risking data decryption and unauthorized access to sensitive information.',
    },
    {
        id: 'airtable-api-key',
        name: 'Airtable API Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a possible Airtable API Key, potentially compromising database access and leading to data leakage or alteration.',
    },
    {
        id: 'airtable-personnal-access-token',
        name: 'Airtable Personnal Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a possible Airtable Personal AccessToken, potentially compromising database access and leading to data leakage or alteration.',
    },
    {
        id: 'algolia-api-key',
        name: 'Algolia API Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified an Algolia API Key, which could result in unauthorized search operations and data exposure on Algolia-managed platforms.',
    },
    {
        id: 'alibaba-access-key-id',
        name: 'Alibaba Access Key ID',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected an Alibaba Cloud AccessKey ID, posing a risk of unauthorized cloud resource access and potential data compromise.',
    },
    {
        id: 'alibaba-secret-key',
        name: 'Alibaba Secret Key',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a potential Alibaba Cloud Secret Key, potentially allowing unauthorized operations and data access within Alibaba Cloud.',
    },
    {
        id: 'anthropic-admin-api-key',
        name: 'Anthropic Admin API Key',
        group: 'AI / LLM providers',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected an Anthropic Admin API Key, risking unauthorized access to administrative functions and sensitive AI model configurations.',
    },
    {
        id: 'anthropic-api-key',
        name: 'Anthropic API Key',
        group: 'AI / LLM providers',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified an Anthropic API Key, which may compromise AI assistant integrations and expose sensitive data to unauthorized access.',
    },
    {
        id: 'artifactory-api-key',
        name: 'Artifactory API Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected an Artifactory api key, posing a risk unauthorized access to the central repository.',
    },
    {
        id: 'artifactory-reference-token',
        name: 'Artifactory Reference Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected an Artifactory reference token, posing a risk of impersonation and unauthorized access to the central repository.',
    },
    {
        id: 'asana-client-id',
        name: 'Asana Client ID',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a potential Asana Client ID, risking unauthorized access to Asana projects and sensitive task information.',
    },
    {
        id: 'asana-client-secret',
        name: 'Asana Client Secret',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified an Asana Client Secret, which could lead to compromised project management integrity and unauthorized access.',
    },
    {
        id: 'atlassian-api-token',
        name: 'Atlassian API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected an Atlassian API token, posing a threat to project management and collaboration tool security and data confidentiality.',
    },
    {
        id: 'authress-service-client-access-key',
        name: 'Authress Service Client Access Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a possible Authress Service Client Access Key, which may compromise access control services and sensitive data.',
    },
    {
        id: 'aws-access-token',
        name: 'AWS Access Token',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a pattern that may indicate AWS credentials, risking unauthorized cloud resource access and data breaches on AWS platforms.',
    },
    {
        id: 'aws-amazon-bedrock-api-key-long-lived',
        name: 'AWS Amazon Bedrock API Key Long Lived',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a pattern that may indicate long-lived Amazon Bedrock API keys, risking unauthorized Amazon Bedrock usage',
    },
    {
        id: 'aws-amazon-bedrock-api-key-short-lived',
        name: 'AWS Amazon Bedrock API Key Short Lived',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a pattern that may indicate short-lived Amazon Bedrock API keys, risking unauthorized Amazon Bedrock usage',
    },
    {
        id: 'azure-ad-client-secret',
        name: 'Azure Ad Client Secret',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Azure AD Client Secret',
    },
    {
        id: 'beamer-api-token',
        name: 'Beamer API Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Beamer API token, potentially compromising content management and exposing sensitive notifications and updates.',
    },
    {
        id: 'bitbucket-client-id',
        name: 'Bitbucket Client ID',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a potential Bitbucket Client ID, risking unauthorized repository access and potential codebase exposure.',
    },
    {
        id: 'bitbucket-client-secret',
        name: 'Bitbucket Client Secret',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a potential Bitbucket Client Secret, posing a risk of compromised code repositories and unauthorized access.',
    },
    {
        id: 'bittrex-access-key',
        name: 'Bittrex Access Key',
        group: 'Payment & finance',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Bittrex Access Key, which could lead to unauthorized access to cryptocurrency trading accounts and financial loss.',
    },
    {
        id: 'bittrex-secret-key',
        name: 'Bittrex Secret Key',
        group: 'Payment & finance',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Bittrex Secret Key, potentially compromising cryptocurrency transactions and financial security.',
    },
    {
        id: 'cisco-meraki-api-key',
        name: 'Cisco Meraki API Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Cisco Meraki is a cloud-managed IT solution that provides networking, security, and device management through an easy-to-use interface.',
    },
    {
        id: 'clickhouse-cloud-api-secret-key',
        name: 'Clickhouse Cloud API Secret Key',
        group: 'Data & secrets platforms',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a pattern that may indicate clickhouse cloud API secret key, risking unauthorized clickhouse cloud api access and data breaches on ClickHouse Cloud platforms.',
    },
    {
        id: 'clojars-api-token',
        name: 'Clojars API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a possible Clojars API token, risking unauthorized access to Clojure libraries and potential code manipulation.',
    },
    {
        id: 'cloudflare-api-key',
        name: 'Cloudflare API Key',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Cloudflare API Key, potentially compromising cloud application deployments and operational security.',
    },
    {
        id: 'cloudflare-global-api-key',
        name: 'Cloudflare Global API Key',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Cloudflare Global API Key, potentially compromising cloud application deployments and operational security.',
    },
    {
        id: 'cloudflare-origin-ca-key',
        name: 'Cloudflare Origin Ca Key',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Cloudflare Origin CA Key, potentially compromising cloud application deployments and operational security.',
    },
    {
        id: 'codecov-access-token',
        name: 'Codecov Access Token',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a pattern resembling a Codecov Access Token, posing a risk of unauthorized access to code coverage reports and sensitive data.',
    },
    {
        id: 'cohere-api-token',
        name: 'Cohere API Token',
        group: 'AI / LLM providers',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Cohere Token, posing a risk of unauthorized access to AI services and data manipulation.',
    },
    {
        id: 'coinbase-access-token',
        name: 'Coinbase Access Token',
        group: 'Payment & finance',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Coinbase Access Token, posing a risk of unauthorized access to cryptocurrency accounts and financial transactions.',
    },
    {
        id: 'confluent-access-token',
        name: 'Confluent Access Token',
        group: 'Data & secrets platforms',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Confluent Access Token, which could compromise access to streaming data platforms and sensitive data flow.',
    },
    {
        id: 'confluent-secret-key',
        name: 'Confluent Secret Key',
        group: 'Data & secrets platforms',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Confluent Secret Key, potentially risking unauthorized operations and data access within Confluent services.',
    },
    {
        id: 'contentful-delivery-api-token',
        name: 'Contentful Delivery API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Contentful delivery API token, posing a risk to content management systems and data integrity.',
    },
    {
        id: 'curl-auth-header',
        name: 'cURL Auth Header',
        group: 'Generic & high-noise',
        source: 'Built-in secret detection ruleset',
        highNoise: true,
        description: 'Discovered a potential authorization token provided in a curl command header, which could compromise the curl accessed resource.',
    },
    {
        id: 'curl-auth-user',
        name: 'cURL Auth User',
        group: 'Generic & high-noise',
        source: 'Built-in secret detection ruleset',
        highNoise: true,
        description: 'Discovered a potential basic authorization token provided in a curl command, which could compromise the curl accessed resource.',
    },
    {
        id: 'databricks-api-token',
        name: 'Databricks API Token',
        group: 'Data & secrets platforms',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Databricks API token, which may compromise big data analytics platforms and sensitive data processing.',
    },
    {
        id: 'datadog-access-token',
        name: 'Datadog Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Datadog Access Token, potentially risking monitoring and analytics data exposure and manipulation.',
    },
    {
        id: 'defined-networking-api-token',
        name: 'Defined Networking API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Defined Networking API token, which could lead to unauthorized network operations and data breaches.',
    },
    {
        id: 'digitalocean-access-token',
        name: 'DigitalOcean Access Token',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a DigitalOcean OAuth Access Token, risking unauthorized cloud resource access and data compromise.',
    },
    {
        id: 'digitalocean-pat',
        name: 'DigitalOcean PAT',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a DigitalOcean Personal Access Token, posing a threat to cloud infrastructure security and data privacy.',
    },
    {
        id: 'digitalocean-refresh-token',
        name: 'DigitalOcean Refresh Token',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a DigitalOcean OAuth Refresh Token, which could allow prolonged unauthorized access and resource manipulation.',
    },
    {
        id: 'discord-api-token',
        name: 'Discord API Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Discord API key, potentially compromising communication channels and user data privacy on Discord.',
    },
    {
        id: 'discord-client-id',
        name: 'Discord Client ID',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Discord client ID, which may lead to unauthorized integrations and data exposure in Discord applications.',
    },
    {
        id: 'discord-client-secret',
        name: 'Discord Client Secret',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a potential Discord client secret, risking compromised Discord bot integrations and data leaks.',
    },
    {
        id: 'doppler-api-token',
        name: 'Doppler API Token',
        group: 'Data & secrets platforms',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Doppler API token, posing a risk to environment and secrets management security.',
    },
    {
        id: 'droneci-access-token',
        name: 'Droneci Access Token',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Droneci Access Token, potentially compromising continuous integration and deployment workflows.',
    },
    {
        id: 'dropbox-api-token',
        name: 'Dropbox API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Dropbox API secret, which could lead to unauthorized file access and data breaches in Dropbox storage.',
    },
    {
        id: 'dropbox-long-lived-api-token',
        name: 'Dropbox Long Lived API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Dropbox long-lived API token, risking prolonged unauthorized access to cloud storage and sensitive data.',
    },
    {
        id: 'dropbox-short-lived-api-token',
        name: 'Dropbox Short Lived API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Dropbox short-lived API token, posing a risk of temporary but potentially harmful data access and manipulation.',
    },
    {
        id: 'duffel-api-token',
        name: 'Duffel API Token',
        group: 'Payment & finance',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Duffel API token, which may compromise travel platform integrations and sensitive customer data.',
    },
    {
        id: 'dynatrace-api-token',
        name: 'Dynatrace API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Dynatrace API token, potentially risking application performance monitoring and data exposure.',
    },
    {
        id: 'easypost-api-token',
        name: 'EasyPost API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified an EasyPost API token, which could lead to unauthorized postal and shipment service access and data exposure.',
    },
    {
        id: 'easypost-test-api-token',
        name: 'EasyPost Test API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected an EasyPost test API token, risking exposure of test environments and potentially sensitive shipment data.',
    },
    {
        id: 'etsy-access-token',
        name: 'Etsy Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found an Etsy Access Token, potentially compromising Etsy shop management and customer data.',
    },
    {
        id: 'facebook-access-token',
        name: 'Facebook Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Facebook Access Token, posing a risk of unauthorized access to Facebook accounts and personal data exposure.',
    },
    {
        id: 'facebook-page-access-token',
        name: 'Facebook Page Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Facebook Page Access Token, posing a risk of unauthorized access to Facebook accounts and personal data exposure.',
    },
    {
        id: 'facebook-secret',
        name: 'Facebook Secret',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Facebook Application secret, posing a risk of unauthorized access to Facebook accounts and personal data exposure.',
    },
    {
        id: 'fastly-api-token',
        name: 'Fastly API Token',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Fastly API key, which may compromise CDN and edge cloud services, leading to content delivery and security issues.',
    },
    {
        id: 'finicity-api-token',
        name: 'Finicity API Token',
        group: 'Payment & finance',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Finicity API token, potentially risking financial data access and unauthorized financial operations.',
    },
    {
        id: 'finicity-client-secret',
        name: 'Finicity Client Secret',
        group: 'Payment & finance',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Finicity Client Secret, which could lead to compromised financial service integrations and data breaches.',
    },
    {
        id: 'finnhub-access-token',
        name: 'Finnhub Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Finnhub Access Token, risking unauthorized access to financial market data and analytics.',
    },
    {
        id: 'flickr-access-token',
        name: 'Flickr Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Flickr Access Token, posing a risk of unauthorized photo management and potential data leakage.',
    },
    {
        id: 'flutterwave-encryption-key',
        name: 'Flutterwave Encryption Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Flutterwave Encryption Key, which may compromise payment processing and sensitive financial information.',
    },
    {
        id: 'flutterwave-public-key',
        name: 'Flutterwave Public Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Finicity Public Key, potentially exposing public cryptographic operations and integrations.',
    },
    {
        id: 'flutterwave-secret-key',
        name: 'Flutterwave Secret Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Flutterwave Secret Key, risking unauthorized financial transactions and data breaches.',
    },
    {
        id: 'flyio-access-token',
        name: 'Flyio Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Fly.io API key',
    },
    {
        id: 'frameio-api-token',
        name: 'Frameio API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Frame.io API token, potentially compromising video collaboration and project management.',
    },
    {
        id: 'freemius-secret-key',
        name: 'Freemius Secret Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Freemius secret key, potentially exposing sensitive information.',
    },
    {
        id: 'freshbooks-access-token',
        name: 'Freshbooks Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Freshbooks Access Token, posing a risk to accounting software access and sensitive financial data exposure.',
    },
    {
        id: 'gcp-api-key',
        name: 'GCP API Key',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a GCP API key, which could lead to unauthorized access to Google Cloud services and data breaches.',
    },
    {
        id: 'generic-api-key',
        name: 'Generic API Key',
        group: 'Generic & high-noise',
        source: 'Built-in secret detection ruleset',
        highNoise: true,
        description: 'Detected a Generic API Key, potentially exposing access to various services and sensitive operations.',
    },
    {
        id: 'github-app-token',
        name: 'GitHub App Token',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a GitHub App Token, which may compromise GitHub application integrations and source code security.',
    },
    {
        id: 'github-fine-grained-pat',
        name: 'GitHub Fine Grained PAT',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a GitHub Fine-Grained Personal Access Token, risking unauthorized repository access and code manipulation.',
    },
    {
        id: 'github-oauth',
        name: 'GitHub OAuth',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a GitHub OAuth Access Token, posing a risk of compromised GitHub account integrations and data leaks.',
    },
    {
        id: 'github-pat',
        name: 'GitHub PAT',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a GitHub Personal Access Token, potentially leading to unauthorized repository access and sensitive content exposure.',
    },
    {
        id: 'github-refresh-token',
        name: 'GitHub Refresh Token',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a GitHub Refresh Token, which could allow prolonged unauthorized access to GitHub services.',
    },
    {
        id: 'gitlab-cicd-job-token',
        name: 'GitLab Cicd Job Token',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a GitLab CI/CD Job Token, potential access to projects and some APIs on behalf of a user while the CI job is running.',
    },
    {
        id: 'gitlab-deploy-token',
        name: 'GitLab Deploy Token',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a GitLab Deploy Token, risking access to repositories, packages and containers with write access.',
    },
    {
        id: 'gitlab-feature-flag-client-token',
        name: 'GitLab Feature Flag Client Token',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a GitLab feature flag client token, risks exposing user lists and features flags used by an application.',
    },
    {
        id: 'gitlab-feed-token',
        name: 'GitLab Feed Token',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a GitLab feed token, risking exposure of user data.',
    },
    {
        id: 'gitlab-incoming-mail-token',
        name: 'GitLab Incoming Mail Token',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a GitLab incoming mail token, risking manipulation of data sent by mail.',
    },
    {
        id: 'gitlab-kubernetes-agent-token',
        name: 'GitLab Kubernetes Agent Token',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a GitLab Kubernetes Agent token, risking access to repos and registry of projects connected via agent.',
    },
    {
        id: 'gitlab-oauth-app-secret',
        name: 'GitLab OAuth App Secret',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a GitLab OIDC Application Secret, risking access to apps using GitLab as authentication provider.',
    },
    {
        id: 'gitlab-pat',
        name: 'GitLab PAT',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a GitLab Personal Access Token, risking unauthorized access to GitLab repositories and codebase exposure.',
    },
    {
        id: 'gitlab-pat-routable',
        name: 'GitLab PAT Routable',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a GitLab Personal Access Token (routable), risking unauthorized access to GitLab repositories and codebase exposure.',
    },
    {
        id: 'gitlab-ptt',
        name: 'GitLab Ptt',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a GitLab Pipeline Trigger Token, potentially compromising continuous integration workflows and project security.',
    },
    {
        id: 'gitlab-rrt',
        name: 'GitLab Rrt',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a GitLab Runner Registration Token, posing a risk to CI/CD pipeline integrity and unauthorized access.',
    },
    {
        id: 'gitlab-runner-authentication-token',
        name: 'GitLab Runner Authentication Token',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a GitLab Runner Authentication Token, posing a risk to CI/CD pipeline integrity and unauthorized access.',
    },
    {
        id: 'gitlab-runner-authentication-token-routable',
        name: 'GitLab Runner Authentication Token Routable',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a GitLab Runner Authentication Token (Routable), posing a risk to CI/CD pipeline integrity and unauthorized access.',
    },
    {
        id: 'gitlab-scim-token',
        name: 'GitLab Scim Token',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a GitLab SCIM Token, posing a risk to unauthorized access for a organization or instance.',
    },
    {
        id: 'gitlab-session-cookie',
        name: 'GitLab Session Cookie',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a GitLab Session Cookie, posing a risk to unauthorized access to a user account.',
    },
    {
        id: 'gitter-access-token',
        name: 'Gitter Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Gitter Access Token, which may lead to unauthorized access to chat and communication services.',
    },
    {
        id: 'gocardless-api-token',
        name: 'Gocardless API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a GoCardless API token, potentially risking unauthorized direct debit payment operations and financial data exposure.',
    },
    {
        id: 'grafana-api-key',
        name: 'Grafana API Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Grafana API key, which could compromise monitoring dashboards and sensitive data analytics.',
    },
    {
        id: 'grafana-cloud-api-token',
        name: 'Grafana Cloud API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Grafana cloud API token, risking unauthorized access to cloud-based monitoring services and data exposure.',
    },
    {
        id: 'grafana-service-account-token',
        name: 'Grafana Service Account Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Grafana service account token, posing a risk of compromised monitoring services and data integrity.',
    },
    {
        id: 'harness-api-key',
        name: 'Harness API Key',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Harness Access Token (PAT or SAT), risking unauthorized access to a Harness account.',
    },
    {
        id: 'hashicorp-tf-api-token',
        name: 'HashiCorp TF API Token',
        group: 'Data & secrets platforms',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a HashiCorp Terraform user/org API token, which may lead to unauthorized infrastructure management and security breaches.',
    },
    {
        id: 'hashicorp-tf-password',
        name: 'HashiCorp TF Password',
        group: 'Data & secrets platforms',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a HashiCorp Terraform password field, risking unauthorized infrastructure configuration and security breaches.',
    },
    {
        id: 'heroku-api-key',
        name: 'Heroku API Key',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Heroku API Key, potentially compromising cloud application deployments and operational security.',
    },
    {
        id: 'heroku-api-key-v2',
        name: 'Heroku API Key V2',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Heroku API Key, potentially compromising cloud application deployments and operational security.',
    },
    {
        id: 'hubspot-api-key',
        name: 'Hubspot API Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a HubSpot API Token, posing a risk to CRM data integrity and unauthorized marketing operations.',
    },
    {
        id: 'huggingface-access-token',
        name: 'HuggingFace Access Token',
        group: 'AI / LLM providers',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Hugging Face Access token, which could lead to unauthorized access to AI models and sensitive data.',
    },
    {
        id: 'huggingface-organization-api-token',
        name: 'HuggingFace Organization API Token',
        group: 'AI / LLM providers',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Hugging Face Organization API token, potentially compromising AI organization accounts and associated data.',
    },
    {
        id: 'infracost-api-token',
        name: 'Infracost API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected an Infracost API Token, risking unauthorized access to cloud cost estimation tools and financial data.',
    },
    {
        id: 'intercom-api-key',
        name: 'Intercom API Key',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified an Intercom API Token, which could compromise customer communication channels and data privacy.',
    },
    {
        id: 'intra42-client-secret',
        name: 'Intra42 Client Secret',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Intra42 client secret, which could lead to unauthorized access to the 42School API and sensitive data.',
    },
    {
        id: 'jfrog-api-key',
        name: 'JFrog API Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a JFrog API Key, posing a risk of unauthorized access to software artifact repositories and build pipelines.',
    },
    {
        id: 'jfrog-identity-token',
        name: 'JFrog Identity Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a JFrog Identity Token, potentially compromising access to JFrog services and sensitive software artifacts.',
    },
    {
        id: 'jwt',
        name: 'JWT',
        group: 'Generic & high-noise',
        source: 'Built-in secret detection ruleset',
        highNoise: true,
        description: 'Uncovered a JSON Web Token, which may lead to unauthorized access to web applications and sensitive user data.',
    },
    {
        id: 'jwt-base64',
        name: 'JWT Base64',
        group: 'Generic & high-noise',
        source: 'Built-in secret detection ruleset',
        highNoise: true,
        description: 'Detected a Base64-encoded JSON Web Token, posing a risk of exposing encoded authentication and data exchange information.',
    },
    {
        id: 'kraken-access-token',
        name: 'Kraken Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Kraken Access Token, potentially compromising cryptocurrency trading accounts and financial security.',
    },
    {
        id: 'kubernetes-secret-yaml',
        name: 'Kubernetes Secret Yaml',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Possible Kubernetes Secret detected, posing a risk of leaking credentials/tokens from your deployments',
    },
    {
        id: 'kucoin-access-token',
        name: 'Kucoin Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Kucoin Access Token, risking unauthorized access to cryptocurrency exchange services and transactions.',
    },
    {
        id: 'kucoin-secret-key',
        name: 'Kucoin Secret Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Kucoin Secret Key, which could lead to compromised cryptocurrency operations and financial data breaches.',
    },
    {
        id: 'launchdarkly-access-token',
        name: 'Launchdarkly Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Launchdarkly Access Token, potentially compromising feature flag management and application functionality.',
    },
    {
        id: 'linear-api-key',
        name: 'Linear API Key',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Linear API Token, posing a risk to project management tools and sensitive task data.',
    },
    {
        id: 'linear-client-secret',
        name: 'Linear Client Secret',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Linear Client Secret, which may compromise secure integrations and sensitive project management data.',
    },
    {
        id: 'linkedin-client-id',
        name: 'LinkedIn Client ID',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a LinkedIn Client ID, risking unauthorized access to LinkedIn integrations and professional data exposure.',
    },
    {
        id: 'linkedin-client-secret',
        name: 'LinkedIn Client Secret',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a LinkedIn Client secret, potentially compromising LinkedIn application integrations and user data.',
    },
    {
        id: 'lob-api-key',
        name: 'Lob API Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Lob API Key, which could lead to unauthorized access to mailing and address verification services.',
    },
    {
        id: 'lob-pub-api-key',
        name: 'Lob Pub API Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Lob Publishable API Key, posing a risk of exposing mail and print service integrations.',
    },
    {
        id: 'looker-client-id',
        name: 'Looker Client ID',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Looker Client ID, risking unauthorized access to a Looker account and exposing sensitive data.',
    },
    {
        id: 'looker-client-secret',
        name: 'Looker Client Secret',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Looker Client Secret, risking unauthorized access to a Looker account and exposing sensitive data.',
    },
    {
        id: 'mailchimp-api-key',
        name: 'Mailchimp API Key',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Mailchimp API key, potentially compromising email marketing campaigns and subscriber data.',
    },
    {
        id: 'mailgun-private-api-token',
        name: 'Mailgun Private API Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Mailgun private API token, risking unauthorized email service operations and data breaches.',
    },
    {
        id: 'mailgun-pub-key',
        name: 'Mailgun Pub Key',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Mailgun public validation key, which could expose email verification processes and associated data.',
    },
    {
        id: 'mailgun-signing-key',
        name: 'Mailgun Signing Key',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Mailgun webhook signing key, potentially compromising email automation and data integrity.',
    },
    {
        id: 'mapbox-api-token',
        name: 'Mapbox API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a MapBox API token, posing a risk to geospatial services and sensitive location data exposure.',
    },
    {
        id: 'mattermost-access-token',
        name: 'Mattermost Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Mattermost Access Token, which may compromise team communication channels and data privacy.',
    },
    {
        id: 'maxmind-license-key',
        name: 'Maxmind License Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a potential MaxMind license key.',
    },
    {
        id: 'messagebird-api-token',
        name: 'Messagebird API Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a MessageBird API token, risking unauthorized access to communication platforms and message data.',
    },
    {
        id: 'messagebird-client-id',
        name: 'Messagebird Client ID',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a MessageBird client ID, potentially compromising API integrations and sensitive communication data.',
    },
    {
        id: 'microsoft-teams-webhook',
        name: 'Microsoft Teams Webhook',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Microsoft Teams Webhook, which could lead to unauthorized access to team collaboration tools and data leaks.',
    },
    {
        id: 'netlify-access-token',
        name: 'Netlify Access Token',
        group: 'Cloud & infrastructure',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Netlify Access Token, potentially compromising web hosting services and site management.',
    },
    {
        id: 'new-relic-browser-api-token',
        name: 'New Relic Browser API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a New Relic ingest browser API token, risking unauthorized access to application performance data and analytics.',
    },
    {
        id: 'new-relic-insert-key',
        name: 'New Relic Insert Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a New Relic insight insert key, compromising data injection into the platform.',
    },
    {
        id: 'new-relic-user-api-id',
        name: 'New Relic User API ID',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a New Relic user API ID, posing a risk to application monitoring services and data integrity.',
    },
    {
        id: 'new-relic-user-api-key',
        name: 'New Relic User API Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a New Relic user API Key, which could lead to compromised application insights and performance monitoring.',
    },
    {
        id: 'notion-api-token',
        name: 'Notion API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Notion API token',
    },
    {
        id: 'npm-access-token',
        name: 'npm Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered an npm access token, potentially compromising package management and code repository access.',
    },
    {
        id: 'nuget-config-password',
        name: 'Nuget Config Password',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a password within a Nuget config file, potentially compromising package management access.',
    },
    {
        id: 'nytimes-access-token',
        name: 'Nytimes Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Nytimes Access Token, risking unauthorized access to New York Times APIs and content services.',
    },
    {
        id: 'octopus-deploy-api-key',
        name: 'Octopus Deploy API Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a potential Octopus Deploy API key, risking application deployments and operational security.',
    },
    {
        id: 'okta-access-token',
        name: 'Okta Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified an Okta Access Token, which may compromise identity management services and user authentication data.',
    },
    {
        id: 'openai-api-key',
        name: 'OpenAI API Key',
        group: 'AI / LLM providers',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found an OpenAI API Key, posing a risk of unauthorized access to AI services and data manipulation.',
    },
    {
        id: 'openshift-user-token',
        name: 'Openshift User Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found an OpenShift user token, potentially compromising an OpenShift/Kubernetes cluster.',
    },
    {
        id: 'perplexity-api-key',
        name: 'Perplexity API Key',
        group: 'AI / LLM providers',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Perplexity API key, which could lead to unauthorized access to Perplexity AI services and data exposure.',
    },
    {
        id: 'pkcs12-file',
        name: 'Pkcs12 File',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a PKCS #12 file, which commonly contain bundled private keys.',
    },
    {
        id: 'plaid-api-token',
        name: 'Plaid API Token',
        group: 'Payment & finance',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Plaid API Token, potentially compromising financial data aggregation and banking services.',
    },
    {
        id: 'plaid-client-id',
        name: 'Plaid Client ID',
        group: 'Payment & finance',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Plaid Client ID, which could lead to unauthorized financial service integrations and data breaches.',
    },
    {
        id: 'plaid-secret-key',
        name: 'Plaid Secret Key',
        group: 'Payment & finance',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Plaid Secret key, risking unauthorized access to financial accounts and sensitive transaction data.',
    },
    {
        id: 'planetscale-api-token',
        name: 'PlanetScale API Token',
        group: 'Data & secrets platforms',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a PlanetScale API token, potentially compromising database management and operations.',
    },
    {
        id: 'planetscale-oauth-token',
        name: 'PlanetScale OAuth Token',
        group: 'Data & secrets platforms',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a PlanetScale OAuth token, posing a risk to database access control and sensitive data integrity.',
    },
    {
        id: 'planetscale-password',
        name: 'PlanetScale Password',
        group: 'Data & secrets platforms',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a PlanetScale password, which could lead to unauthorized database operations and data breaches.',
    },
    {
        id: 'postman-api-token',
        name: 'Postman API Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Postman API token, potentially compromising API testing and development workflows.',
    },
    {
        id: 'prefect-api-token',
        name: 'Prefect API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Prefect API token, risking unauthorized access to workflow management and automation services.',
    },
    {
        id: 'private-key',
        name: 'Private Key',
        group: 'Generic & high-noise',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Private Key, which may compromise cryptographic security and sensitive data encryption.',
    },
    {
        id: 'privateai-api-token',
        name: 'Privateai API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a PrivateAI Token, posing a risk of unauthorized access to AI services and data manipulation.',
    },
    {
        id: 'pulumi-api-token',
        name: 'Pulumi API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Pulumi API token, posing a risk to infrastructure as code services and cloud resource management.',
    },
    {
        id: 'pypi-upload-token',
        name: 'Pypi Upload Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a PyPI upload token, potentially compromising Python package distribution and repository integrity.',
    },
    {
        id: 'rapidapi-access-token',
        name: 'Rapidapi Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a RapidAPI Access Token, which could lead to unauthorized access to various APIs and data services.',
    },
    {
        id: 'readme-api-token',
        name: 'Readme API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Readme API token, risking unauthorized documentation management and content exposure.',
    },
    {
        id: 'rubygems-api-token',
        name: 'Rubygems API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Rubygem API token, potentially compromising Ruby library distribution and package management.',
    },
    {
        id: 'scalingo-api-token',
        name: 'Scalingo API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Scalingo API token, posing a risk to cloud platform services and application deployment security.',
    },
    {
        id: 'sendbird-access-id',
        name: 'Sendbird Access ID',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Sendbird Access ID, which could compromise chat and messaging platform integrations.',
    },
    {
        id: 'sendbird-access-token',
        name: 'Sendbird Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Sendbird Access Token, potentially risking unauthorized access to communication services and user data.',
    },
    {
        id: 'sendgrid-api-token',
        name: 'SendGrid API Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a SendGrid API token, posing a risk of unauthorized email service operations and data exposure.',
    },
    {
        id: 'sendinblue-api-token',
        name: 'Sendinblue API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Sendinblue API token, which may compromise email marketing services and subscriber data privacy.',
    },
    {
        id: 'sentry-access-token',
        name: 'Sentry Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Sentry.io Access Token (old format), risking unauthorized access to error tracking services and sensitive application data.',
    },
    {
        id: 'sentry-org-token',
        name: 'Sentry Org Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Sentry.io Organization Token, risking unauthorized access to error tracking services and sensitive application data.',
    },
    {
        id: 'sentry-user-token',
        name: 'Sentry User Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Sentry.io User Token, risking unauthorized access to error tracking services and sensitive application data.',
    },
    {
        id: 'settlemint-application-access-token',
        name: 'SettleMint Application Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Settlemint Application Access Token.',
    },
    {
        id: 'settlemint-personal-access-token',
        name: 'SettleMint Personal Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Settlemint Personal Access Token.',
    },
    {
        id: 'settlemint-service-access-token',
        name: 'SettleMint Service Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Settlemint Service Access Token.',
    },
    {
        id: 'shippo-api-token',
        name: 'Shippo API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Shippo API token, potentially compromising shipping services and customer order data.',
    },
    {
        id: 'shopify-access-token',
        name: 'Shopify Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Shopify access token, which could lead to unauthorized e-commerce platform access and data breaches.',
    },
    {
        id: 'shopify-custom-access-token',
        name: 'Shopify Custom Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Shopify custom access token, potentially compromising custom app integrations and e-commerce data security.',
    },
    {
        id: 'shopify-private-app-access-token',
        name: 'Shopify Private App Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Shopify private app access token, risking unauthorized access to private app data and store operations.',
    },
    {
        id: 'shopify-shared-secret',
        name: 'Shopify Shared Secret',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Shopify shared secret, posing a risk to application authentication and e-commerce platform security.',
    },
    {
        id: 'sidekiq-secret',
        name: 'Sidekiq Secret',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Sidekiq Secret, which could lead to compromised background job processing and application data breaches.',
    },
    {
        id: 'sidekiq-sensitive-url',
        name: 'Sidekiq Sensitive URL',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Sidekiq Sensitive URL, potentially exposing internal job queues and sensitive operation details.',
    },
    {
        id: 'slack-app-token',
        name: 'Slack App Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Slack App-level token, risking unauthorized access to Slack applications and workspace data.',
    },
    {
        id: 'slack-bot-token',
        name: 'Slack Bot Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Slack Bot token, which may compromise bot integrations and communication channel security.',
    },
    {
        id: 'slack-config-access-token',
        name: 'Slack Config Access Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Slack Configuration access token, posing a risk to workspace configuration and sensitive data access.',
    },
    {
        id: 'slack-config-refresh-token',
        name: 'Slack Config Refresh Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Slack Configuration refresh token, potentially allowing prolonged unauthorized access to configuration settings.',
    },
    {
        id: 'slack-legacy-bot-token',
        name: 'Slack Legacy Bot Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Slack Legacy bot token, which could lead to compromised legacy bot operations and data exposure.',
    },
    {
        id: 'slack-legacy-token',
        name: 'Slack Legacy Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Slack Legacy token, risking unauthorized access to older Slack integrations and user data.',
    },
    {
        id: 'slack-legacy-workspace-token',
        name: 'Slack Legacy Workspace Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Slack Legacy Workspace token, potentially compromising access to workspace data and legacy features.',
    },
    {
        id: 'slack-user-token',
        name: 'Slack User Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Slack User token, posing a risk of unauthorized user impersonation and data access within Slack workspaces.',
    },
    {
        id: 'slack-webhook-url',
        name: 'Slack Webhook URL',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Slack Webhook, which could lead to unauthorized message posting and data leakage in Slack channels.',
    },
    {
        id: 'snyk-api-token',
        name: 'Snyk API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Snyk API token, potentially compromising software vulnerability scanning and code security.',
    },
    {
        id: 'sonar-api-token',
        name: 'Sonar API Token',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Sonar API token, potentially compromising software vulnerability scanning and code security.',
    },
    {
        id: 'sourcegraph-access-token',
        name: 'Sourcegraph Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Sourcegraph is a code search and navigation engine.',
    },
    {
        id: 'square-access-token',
        name: 'Square Access Token',
        group: 'Payment & finance',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Square Access Token, risking unauthorized payment processing and financial transaction exposure.',
    },
    {
        id: 'squarespace-access-token',
        name: 'Squarespace Access Token',
        group: 'Payment & finance',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Squarespace Access Token, which may compromise website management and content control on Squarespace.',
    },
    {
        id: 'stripe-access-token',
        name: 'Stripe Access Token',
        group: 'Payment & finance',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Stripe Access Token, posing a risk to payment processing services and sensitive financial data.',
    },
    {
        id: 'sumologic-access-id',
        name: 'Sumologic Access ID',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a SumoLogic Access ID, potentially compromising log management services and data analytics integrity.',
    },
    {
        id: 'sumologic-access-token',
        name: 'Sumologic Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a SumoLogic Access Token, which could lead to unauthorized access to log data and analytics insights.',
    },
    {
        id: 'telegram-bot-api-token',
        name: 'Telegram Bot API Token',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Telegram Bot API Token, risking unauthorized bot operations and message interception on Telegram.',
    },
    {
        id: 'travisci-access-token',
        name: 'Travisci Access Token',
        group: 'Source control & CI/CD',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Travis CI Access Token, potentially compromising continuous integration services and codebase security.',
    },
    {
        id: 'twilio-api-key',
        name: 'Twilio API Key',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Twilio API Key, posing a risk to communication services and sensitive customer interaction data.',
    },
    {
        id: 'twitch-api-token',
        name: 'Twitch API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Twitch API token, which could compromise streaming services and account integrations.',
    },
    {
        id: 'twitter-access-secret',
        name: 'Twitter Access Secret',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Twitter Access Secret, potentially risking unauthorized Twitter integrations and data breaches.',
    },
    {
        id: 'twitter-access-token',
        name: 'Twitter Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Twitter Access Token, posing a risk of unauthorized account operations and social media data exposure.',
    },
    {
        id: 'twitter-api-key',
        name: 'Twitter API Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Twitter API Key, which may compromise Twitter application integrations and user data security.',
    },
    {
        id: 'twitter-api-secret',
        name: 'Twitter API Secret',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Twitter API Secret, risking the security of Twitter app integrations and sensitive data access.',
    },
    {
        id: 'twitter-bearer-token',
        name: 'Twitter Bearer Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Twitter Bearer Token, potentially compromising API access and data retrieval from Twitter.',
    },
    {
        id: 'typeform-api-token',
        name: 'Typeform API Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Typeform API token, which could lead to unauthorized survey management and data collection.',
    },
    {
        id: 'vault-batch-token',
        name: 'Vault Batch Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Vault Batch Token, risking unauthorized access to secret management services and sensitive data.',
    },
    {
        id: 'vault-service-token',
        name: 'Vault Service Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Identified a Vault Service Token, potentially compromising infrastructure security and access to sensitive credentials.',
    },
    {
        id: 'yandex-access-token',
        name: 'Yandex Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Found a Yandex Access Token, posing a risk to Yandex service integrations and user data privacy.',
    },
    {
        id: 'yandex-api-key',
        name: 'Yandex API Key',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Discovered a Yandex API Key, which could lead to unauthorized access to Yandex services and data manipulation.',
    },
    {
        id: 'yandex-aws-access-token',
        name: 'Yandex AWS Access Token',
        group: 'Other SaaS & services',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Uncovered a Yandex AWS Access Token, potentially compromising cloud resource access and data security on Yandex Cloud.',
    },
    {
        id: 'zendesk-secret-key',
        name: 'Zendesk Secret Key',
        group: 'Communication & messaging',
        source: 'Built-in secret detection ruleset',
        highNoise: false,
        description: 'Detected a Zendesk Secret Key, risking unauthorized access to customer support services and sensitive ticketing data.',
    },
];
/** Lookup by rule ID. */
export const GITLEAKS_RULES_BY_ID = new Map(GITLEAKS_RULES.map(rule => [rule.id, rule]));
/** Category headings, in the order the editor should render them. */
export const GITLEAKS_RULE_GROUPS = [
    'Other SaaS & services',
    'Cloud & infrastructure',
    'AI / LLM providers',
    'Communication & messaging',
    'Source control & CI/CD',
    'Payment & finance',
    'Data & secrets platforms',
    'Generic & high-noise',
];
//# sourceMappingURL=gitleaks-rules.js.map